import { Button } from 'react-bootstrap'
import styled from 'styled-components'
import { Card } from '../../../components'

export const DatePickerWrapper = styled.div`
  margin-top: 10px;
  width: 30%;
  display: flex;
  flex-direction: row;
  @media (max-width: 415px) {
    width: 100%;
  }

  .react-datepicker-wrapper {
    height: 45px;
  }
`
export const ResetButton = styled(Button)`
  height: 30px;
  position: relative;
  top: 20px;
  margin-left: 5px;
`

export const CardWrapper = styled(Card)`
  width: 45%;
  padding: 0 32px 16px;
  @media (max-width: 415px) {
    width: 100%;
    margin-bottom: 16px;
  }
`
